import React from 'react';

export const renderQuizPreview = (content: any) => {
  const hasQuestions = content.questions && Array.isArray(content.questions) && content.questions.length > 0;
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Câu hỏi trắc nghiệm đã tạo:</h5>
      {hasQuestions ? (
        <div className="space-y-2 max-h-[66vh] overflow-y-auto">
          {content.questions.map((question: any, index: number) => (
            <div key={index} className="border border-gray-200 rounded p-2 bg-gray-50">
              <p className="font-medium text-sm text-gray-800 mb-1">
                {index + 1}. {typeof question.question === 'string' ? question.question : question.text || JSON.stringify(question)}
              </p>
              {question.options && Array.isArray(question.options) && (
                <div className="space-y-1">
                  {question.options.map((option: any, optIndex: number) => (
                    <p key={optIndex} className="text-xs text-gray-600 ml-2">
                      {String.fromCharCode(65 + optIndex)}. {typeof option === 'string' ? option : option.text || JSON.stringify(option)}
                    </p>
                  ))}
                </div>
              )}
              {question.correct_answer && (
                <p className="text-xs text-green-600 mt-1 font-medium">
                  Đáp án đúng: {typeof question.correct_answer === 'string' ? question.correct_answer : question.correct_answer.text || JSON.stringify(question.correct_answer)}
                </p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-sm">Không có câu hỏi nào được tạo</p>
      )}
    </div>
  );
};

export const renderLessonPreview = (content: any) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Nội dung bài học đã tạo:</h5>
      <div className="max-h-[66vh] overflow-y-auto">
        {content.content && (
          <div className="prose prose-sm max-w-none text-sm">
            <div dangerouslySetInnerHTML={{ __html: content.content }} />
          </div>
        )}
        {content.summary && (
          <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded">
            <h6 className="font-medium text-blue-900 mb-1 text-sm">Tóm tắt:</h6>
            <p className="text-xs text-blue-800">{content.summary}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export const renderAssignmentPreview = (content: any) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Nội dung bài tập đã tạo:</h5>
      <div className="max-h-[66vh] overflow-y-auto">
        {content.instructions && (
          <div className="mb-3">
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Hướng dẫn:</h6>
            <p className="text-sm text-gray-700">{content.instructions}</p>
          </div>
        )}
        {content.requirements && (
          <div className="mb-3">
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Yêu cầu:</h6>
            <ul className="text-sm text-gray-700 list-disc list-inside">
              {content.requirements.map((req: string, index: number) => (
                <li key={index}>{req}</li>
              ))}
            </ul>
          </div>
        )}
        {content.criteria && (
          <div>
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Tiêu chí đánh giá:</h6>
            <ul className="text-sm text-gray-700 list-disc list-inside">
              {content.criteria.map((criterion: string, index: number) => (
                <li key={index}>{criterion}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export const renderExercisePreview = (content: any) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Nội dung bài thực hành đã tạo:</h5>
      <div className="max-h-[66vh] overflow-y-auto">
        {content.description && (
          <div className="mb-3">
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Mô tả:</h6>
            <p className="text-sm text-gray-700">{content.description}</p>
          </div>
        )}
        {content.steps && Array.isArray(content.steps) && (
          <div className="mb-3">
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Các bước thực hiện:</h6>
            <ol className="text-sm text-gray-700 list-decimal list-inside">
              {content.steps.map((step: string, index: number) => (
                <li key={index}>{step}</li>
              ))}
            </ol>
          </div>
        )}
        {content.expected_outcome && (
          <div>
            <h6 className="font-medium text-gray-800 mb-1 text-sm">Kết quả mong đợi:</h6>
            <p className="text-sm text-gray-700">{content.expected_outcome}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export const renderModuleStructurePreview = (content: any) => {
  console.log('Module structure preview content:', content);
  
  // Handle nested structure: content.content.sections
  let sections = content.sections;
  if (content.content && content.content.sections) {
    sections = content.content.sections;
  }
  
  const hasSections = sections && Array.isArray(sections) && sections.length > 0;
  
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Cấu trúc module đã tạo:</h5>
      {hasSections ? (
        <div className="space-y-2 max-h-[66vh] overflow-y-auto">
          {sections.map((section: any, index: number) => (
            <div key={index} className="border border-gray-200 rounded p-2 bg-gray-50">
              <div className="flex items-center justify-between mb-1">
                <p className="font-medium text-sm text-gray-800">
                  Section {index + 1}: {section.name || 'Unnamed Section'}
                </p>
                <span className="text-xs text-gray-500 bg-gray-200 px-2 py-1 rounded">
                  {section.delivery_method || 'e-learning'}
                </span>
              </div>
              {section.activities && Array.isArray(section.activities) && section.activities.length > 0 ? (
                <div className="space-y-1">
                  {section.activities.map((activity: any, actIndex: number) => (
                    <div key={actIndex} className="ml-3 border-l-2 border-blue-200 pl-2">
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-blue-600 font-medium">
                          {activity.type || 'activity'}
                        </span>
                        <p className="text-xs text-gray-700">
                          {activity.title || 'Untitled Activity'}
                        </p>
                      </div>
                      {activity.description && (
                        <p className="text-xs text-gray-500 mt-1 ml-4">
                          {activity.description}
                        </p>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-gray-500 ml-3">Không có hoạt động nào</p>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-sm">Không có section nào được tạo</p>
      )}
    </div>
  );
};

export const renderDefaultPreview = (content: any) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <h5 className="font-medium text-gray-900 mb-2">Nội dung đã tạo:</h5>
      <div className="max-h-[66vh] overflow-y-auto">
        <pre className="text-xs text-gray-700 whitespace-pre-wrap bg-gray-50 p-2 rounded border">
          {JSON.stringify(content, null, 2)}
        </pre>
      </div>
    </div>
  );
};

// Factory function to get the appropriate preview renderer based on activity type
export const getPreviewRenderer = (activityType: string) => {
  switch (activityType) {
    case 'quiz':
      return renderQuizPreview;
    case 'lesson':
      return renderLessonPreview;
    case 'assignment':
      return renderAssignmentPreview;
    case 'exercise':
      return renderExercisePreview;
    case 'module_structure':
      return renderModuleStructurePreview;
    default:
      return renderDefaultPreview;
  }
}; 